<template lang="pug">
    div.fluid.ma-0.pa-0.fill-height(v-if="validGroupType" style="height: 100vh;" ref="indexBody")
        v-snackbar(
            v-model='snackbar.show'
            :color='snackbar.color'
            :timeout="snackbar.timeout"
            top
        )
            | {{ snackbar.text }}
            v-btn(dark text @click='snackbar.show = false')
                | Close

        .text-center(v-if="isLoading")
            v-progress-circular(
                :size='100'
                :width='10'
                color='var(--volie-blue)'
                indeterminate
                style="margin-top: 100px; margin-bottom: 100px;"
            )

        template(v-else)
            v-row.table-x-scroll(
                no-gutters
            ).brown.lighten-5
                v-col(
                    v-if="paddingCols > 0"
                    :cols="paddingCols"
                )
                    .brown.lighten-5.mx-lg-auto.pa-md-4(style="height: 100vh;")

                v-col(:cols="conversationGroupCardCols")
                    v-card.brown.lighten-5.mx-lg-auto.pa-md-4.rounded-lg(
                        width="100%"
                        v-bind:style="{ height: bodyHeight + 'px' }"
                        outlined
                        tile
                    )
                        v-toolbar(
                            color="var(--off-white)"
                            light
                            dense
                        )
                            v-responsive.d-flex.align-center(style="min-height: 100%;")
                                v-row
                                    v-col(cols="11")
                                        v-row.d-flex.justify-end(v-if="showSearch")
                                            v-btn.ma-2(
                                                color="var(--volie-blue)" 
                                                outlined 
                                                ripple 
                                                @click='showSearch = false; resetAndSearch();'
                                                )
                                                v-icon mdi-refresh
                                                | Reset
                                            v-btn.ma-2(color="var(--volie-blue)" outlined ripple @click='showSearch = false; search();')
                                                v-icon mdi-magnify
                                                | Search

                                        template(v-else) Messages
                                    v-col.d-flex.justify-end(cols="1" style="gap: 15px; min-height: 100%;")
                                        v-tooltip(v-if="!showSearch" top)
                                            template(v-slot:activator='{ on, attrs }')
                                                v-icon(v-bind="attrs" v-on="on" @click='resetAndSearch()')
                                                    | mdi-refresh
                                            span
                                                | Reset Search
                                        v-icon.mr-2(v-if="showSearch" @click='showSearch = false;') mdi-window-close
                                        v-tooltip(v-else top)
                                            template(v-slot:activator='{ on, attrs }')
                                                v-icon.mr-2(v-bind="attrs" v-on="on" @click='showSearch = !showSearch')
                                                    | mdi-magnify
                                            | Search Messages

                        template(v-if="showSearch")
                            v-card-text.overflow-y-auto.pa-0(
                                v-bind:style="{ height: cgCardHeight + 'px' }"
                            )
                                v-card.mx-lg-auto(
                                    outlined
                                    width="100%"
                                    rounded
                                    style="height: 100vh;"
                                )
                                    v-card-text
                                        v-container
                                            v-row
                                                v-col.no-top-bottom-padding(cols='6')
                                                    v-menu(
                                                        v-model='startDatePickerMenu'
                                                        :close-on-content-click='false'
                                                        transition='scale-transition'
                                                        offset-y
                                                        max-width='290px'
                                                        min-width='290px'
                                                    )
                                                        template(v-slot:activator='{ on, attrs }')
                                                            v-text-field(
                                                                v-model='formatStartTimeDate'
                                                                label='Start Date'
                                                                prepend-icon='mdi-calendar'
                                                                readonly
                                                                v-bind='attrs'
                                                                v-on='on'
                                                                clearable
                                                                @click:clear='searchObj.start_date = null;'
                                                            )
                                                        v-date-picker(
                                                            v-model='searchObj.start_date'
                                                            no-title
                                                            @change="handleChangeStartDate"
                                                            @input='startDatePickerMenu = false'
                                                        )
                                                v-col.no-top-bottom-padding(cols='6')
                                                    v-menu(
                                                        v-model='endDatePickerMenu'
                                                        :close-on-content-click='false'
                                                        transition='scale-transition'
                                                        offset-y
                                                        max-width='290px'
                                                        min-width='290px'
                                                    )
                                                        template(v-slot:activator='{ on, attrs }')
                                                            v-text-field(
                                                                v-model='formatEndTimeDate'
                                                                label='End Date'
                                                                prepend-icon='mdi-calendar'
                                                                readonly
                                                                v-bind='attrs'
                                                                v-on='on'
                                                                clearable
                                                                @click:clear='searchObj.end_date = null;'
                                                            )
                                                        v-date-picker(
                                                            v-model='searchObj.end_date'
                                                            no-title
                                                            @change="handleChangeEndDate"
                                                            @input='endDatePickerMenu = false'
                                                        )

                                            v-row
                                                v-col(cols='12')
                                                    OrganizationSelect(
                                                        v-model='searchObj.organizationIds'
                                                        :organization-users='organizationUsers'
                                                        :multiple='true'
                                                        label='Organization'
                                                        clearable
                                                    )

                                            v-row
                                                v-col(cols='6')
                                                    CustomerSearch(
                                                        :dense="true"
                                                        :email="searchObj.customerEmail"
                                                        :handle-search="handleCustomerSearch"
                                                        :first-name="searchObj.customerFirstName"
                                                        :last-name="searchObj.customerLastName"
                                                        :organization-id="searchObj.organizationId"
                                                        :organization-users="organizationUsers"
                                                        :outlined="true"
                                                        :phone="searchObj.customerPhone"
                                                    )

                                                v-col(cols='6')
                                                    v-text-field(
                                                        v-model='searchObj.vin'
                                                        label='VIN'
                                                        type='text'
                                                        clearable
                                                        outlined
                                                        dense
                                                    )

                                            v-row
                                                v-col.no-padding-top-bottom(cols='12')
                                                    v-checkbox(
                                                        v-model='searchObj.has_unresponded_incoming_message'
                                                        ripple
                                                        label="Customer awaiting response"
                                                    )

                                            v-row
                                                v-col.no-padding-top-bottom(cols='12')
                                                    v-checkbox(
                                                        v-model='searchObj.has_unresponded_outgoing_message'
                                                        ripple
                                                        label="Customer received message but has not responded"
                                                    )
                                            v-row
                                                v-col.no-padding-top-bottom(cols='12')
                                                    v-checkbox(
                                                        v-model='searchObj.has_unread_messages'
                                                        ripple
                                                        label="Has unread messages"
                                                    )
                                            v-row
                                                v-col.no-padding-top-bottom(cols='12')
                                                    v-checkbox(
                                                        v-model='searchObj.has_affinity'
                                                        ripple
                                                        label="Enforce affinity"
                                                    )
                                            v-row
                                                v-col.no-padding-top-bottom(cols="12")
                                                    v-radio-group(v-model="searchObj.sortByColumnName")
                                                        template(v-slot:label)
                                                            label(style="font-size: 12px;")
                                                                | Sort Preference
                                                        v-radio(
                                                            style="margin-left: 10px;"
                                                            v-for="(option, idx) in sortByColumnNames"
                                                            :label='option.key'
                                                            :value="option.value"
                                                            :key="idx"
                                                        )

                        v-card-text.overflow-y-auto.pa-0#cg-index(
                            v-else
                            v-bind:style="{ height: cgCardHeight + 'px' }"
                        )
                            v-card.mx-lg-auto(
                                v-if="validConversationGroups"
                                outlined
                                width="100%"
                                rounded
                                style="height: 100vh;"
                            )
                                v-card-text.pa-0
                                    ConversationGroupCard(
                                        v-for='cg in conversationGroups'
                                        :key='cg.conversation_group_id'
                                        :conversation-group="cg"
                                        :enter-manual-mode="enterManualMode"
                                        :selected-components="selectedComponents"
                                        :select-conversation-group="selectConversationGroup"
                                        :selected-conversation-group-id="selectedConversationGroupID"
                                        :show-snackbar="showSnackbar"
                                    )

                                    .text-center(v-if="isShowMoreLoading")
                                        v-progress-circular(
                                            :size='50'
                                            :width='10'
                                            color='var(--volie-blue)'
                                            indeterminate
                                            style="margin-top: 100px; margin-bottom: 100px;"
                                        )

                            v-card.mx-lg-auto(
                                v-else
                                outlined
                                width="100%"
                                rounded
                                style="height: 100vh;"
                            )
                                v-card-text.pb-sm-2(style="padding-left: 100px; padding-right: 100px;")
                                    v-alert(outlined type='info' dense border='left' style="margin-top: 0px;")
                                        | Zero conversation groups found

                template(v-if="validSelectedConversationGroup")
                    v-col(
                        v-if="renderCustomerProfile"
                        cols="8"
                    )
                        BaseCustomerProfile(
                            :customer-id="customerID"
                            :exit="exit"
                            :source="sourceValue"
                        )

                    v-col(
                        v-if="renderEmailClient"
                        cols="4"
                    )
                        .brown.lighten-5.mx-lg-auto.pa-md-4
                            EmailClient(
                                v-bind:style="{ height: compHeight + 'px' }"
                                :account-id="accountID"
                                :client-height="compHeight"
                                :customer-id="customerID"
                                :exit="exit"
                                :show-snackbar="showSnackbar"
                            )
                            //- :audio-email-incoming="audioEmailIncoming"
                            //- :audio-email-outcoming="audioEmailOutcoming"

                    v-col(
                        v-if="renderMessageSoftphone"
                        cols="4"
                    )
                        .brown.lighten-5.mx-lg-auto.pa-md-4
                            MessageSoftphone.pa-2(
                                v-bind:style="{ height: compHeight + 'px' }"
                                :account-id="accountID"
                                :customer-id="customerID"
                                :customer-phone-number-id="customerPhoneNumberID"
                                :exit="exit"
                                :filtered-message-id="filteredMessageID"
                                :incoming-phone-number-id="twilioNumberID"
                                :soft-phone-height="compHeight"
                            )

                v-col(
                    v-if="paddingCols > 0"
                    :cols="paddingCols"
                )
                    .brown.lighten-5.mx-lg-auto.pa-md-4(style="height: 100vh;")

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import BaseCustomerProfile from '@/components/customers/base_customer_profile.vue';
    import ConversationGroupCard from '@/components/conversation_groups/card.vue';
    import CustomerSearch from "@/components/customers/contact_info_search.vue";
    import EmailClient from '@/components/communication_center/email/email_client.vue';
    import MessageSoftphone from '@/components/communication_center/sms_message/softphone.vue';
    import OrganizationSelect from '@/components/shared/organization_select.vue';

    // Data
    import {
        GetConversationGroups,
        GetOrganizationUsers,
    } from "@/data";

    export default Vue.extend({
        data() {
            return {
                bodyHeight: null,
                bodyWidth: null,
                cgCardHeight: null,
                compHeight: null,
                conversationGroups: [],
                conversationGroupDiv: null,
                endDatePickerMenu: false,
                formatEndTimeDate: null,
                formatStartTimeDate: null,
                groupTypes: ["customer_to_caller_id", "user_to_user"],
                isLoading: false,
                isShowMoreLoading: false,
                limit: 100,
                organizationUsers: [],
                showSearch: false,
                searchObj: {
                    customerEmail: null,
                    customerFirstName: null,
                    customerLastName: null,
                    customerPhone: null,
                    has_affinity: false,
                    has_unread_messages: false,
                    has_unresponded_incoming_message: false,
                    has_unresponded_outgoing_message: false,
                    organizationId: null,
                    organizationIds: [],
                    sortByColumnName: "most_recent",
                    vin: null,
                },
                selectedComponents: [],
                selectedConversationGroup: null,
                snackbar: {
                    show: false,
                    timeout: 2500,
                },
                sortByColumnNames: [
                    { key: "Most Recent", value: "most_recent" },
                    { key: "Longest Waiting", value: "longest_waiting" },
                ],
                startDatePickerMenu: false,
            }
        },
        methods: {
            exit() {
                this.selectedConversationGroup = null;
                this.selectedComponents = [];
            },
            formatDate (date) {
                if (!date) {
                    return null;
                }

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`;
            },
            async getConversationGroups() {

                const options = {
                    customer_email: (this.searchObj?.customerEmail || ""),
                    customer_first_name: (this.searchObj?.customerFirstName || ""),
                    customer_last_name: (this.searchObj?.customerLastName || ""),
                    customer_phone: (this.searchObj?.customerPhone || ""),
                    end_date: this.searchObj.end_date || '',
                    exclude_conversation_group_ids: this.conversationGroupIDs,
                    group_type: this.groupType,
                    has_affinity: (this.searchObj?.has_affinity || false),
                    has_unread_messages: (this.searchObj?.has_unread_messages || false),
                    has_unresponded_incoming_message: (this.searchObj?.has_unresponded_incoming_message || false),
                    has_unresponded_outgoing_message: (this.searchObj?.has_unresponded_outgoing_message || false),
                    limit: this.limit,
                    organization_id: (this.searchObj?.organizationId || 0),
                    organization_ids: (this.searchObj?.organizationIds || []),
                    sort_by_column_name: (this.searchObj?.sortByColumnName || ''),
                    start_date: this.searchObj.start_date || '',
                    vehicle_vin: (this.searchObj?.vin || ""),
                }

                // remove existing scroll listener before we move forward
                this.removeScrollListener();

                if (this.conversationGroups?.length > 0) {
                    this.isShowMoreLoading = true;
                } else {
                    this.isLoading = true;
                }
                
                await GetConversationGroups(options).then((response) => {
                    if (response?.Data?.conversation_groups?.length > 0) {

                        this.showMoreable = true;

                        // only sort new stuff
                        this.conversationGroups = this.conversationGroups.concat(this.sortConversationGroups(response.Data.conversation_groups.slice()));
                    } else {
                        this.showMoreable = false;
                    }

                    this.isLoading = false;
                    this.isShowMoreLoading = false;
                });

                // now init scroll listener if we have conversation groups
                if (this.validConversationGroups && !this.conversationGroupDiv) {
                    this.$nextTick(() => {
                        requestAnimationFrame(() => {
                            this.initScrollListener();
                        });
                    });
                }
            },
            getOrganizationUsers() {
                GetOrganizationUsers().then((response) => {
                    if (!!response.Data && !!response.Data.organization_users && response.Data.organization_users.length > 0) {
                        this.organizationUsers = response.Data.organization_users;
                    }
                });

                return;
            },
            handleChangeEndDate() {
                this.formatEndTimeDate = this.formatDate(this.searchObj?.end_date);
            },
            handleChangeStartDate() {
                this.formatStartTimeDate = this.formatDate(this.searchObj?.start_date);
            },
            handleCustomerSearch(obj) {
                this.searchObj.customerEmail     = obj?.email || null;
                this.searchObj.customerFirstName = obj?.firstName || null;
                this.searchObj.customerLastName  = obj?.lastName || null;
                this.searchObj.customerPhone     = obj?.phone || null;
                this.searchObj.organizationId    = obj?.organizationId || null;
            },
            handleWindowResize() {

                // Declare constants
                // const paddingPx = 2;
                // const toolbarHeight = 48;
                // const tabBarHeight = 48;
                // const colPaddingAndMargin = 47.109;
                let liveDash = 0;
                if (this.source === "live_dashboard") {
                    liveDash = 64; // banner
                }

                // Calcuate
                this.bodyHeight = this.$refs.indexBody?.clientHeight - liveDash;
                this.bodyWidth = this.$refs.indexBody?.clientWidth;
                this.compHeight = this.bodyHeight - 32 - 64;
                this.cgCardHeight = this.compHeight - 50;
            },
            handleScroll() {

                // verify
                if (!this.conversationGroupDiv) {
                    return;
                }

                // check if scrolled near the bottom (subpixel/zoom can miss an exact match)
                const remaining = this.conversationGroupDiv.scrollHeight - this.conversationGroupDiv.scrollTop - this.conversationGroupDiv.clientHeight;
                if (remaining > 1) {
                    return;
                }

                // ensure we are not already loading more
                if (this.isShowMoreLoading) {
                    return;
                }

                // if we know that there aren't any more, do nothing
                if (!this.showMoreable) {
                    return;
                }

                // load more, excluding what we have already loaded
                this.getConversationGroups();
            },
            initScrollListener() {

                // if we already have a div, do nothing (means we are loading more or sorting)
                if (this.conversationGroupDiv || !this.validConversationGroups) {
                    return;
                }

                // find on dom
                this.conversationGroupDiv = document.getElementById('cg-index');
                if (!this.conversationGroupDiv) {
                    return;
                }

                // add scroll listener
                this.conversationGroupDiv.addEventListener('scroll', this.handleScroll);
            },
            removeScrollListener() {
                if (!this.conversationGroupDiv) {
                    return;
                }

                // unset
                this.conversationGroupDiv.removeEventListener('scroll', this.handleScroll);
                this.conversationGroupDiv = null;
            },
            resetAndSearch() {
                this.resetSearchObject();
                this.search();
            },
            resetSearchObject() {
                this.searchObj = {
                    customerEmail: null,
                    customerFirstName: null,
                    customerLastName: null,
                    customerPhone: null,
                    end_date: null,
                    has_affinity: false,
                    has_unread_messages: false,
                    has_unresponded_incoming_message: false,
                    has_unresponded_outgoing_message: false,
                    organizationId: null,
                    organizationIds: [],
                    sortByColumnName: "most_recent",
                    start_date: null,
                    vin: null,
                }
                this.formatStartTimeDate = null;
                this.formatEndTimeDate = null;
            },
            search() {
                this.removeScrollListener();
                this.conversationGroups = [];
                this.getConversationGroups();
            },
            selectConversationGroup(conversationGroup, comp) {

                // Check if it is the same cg and just append to array
                if (this.selectedConversationGroupID === conversationGroup?.conversation_group_id) {
                    const idx = this.selectedComponents.indexOf(comp);
                    if (idx >= 0) {
                        this.selectedComponents.splice(idx, 1);
                    } else {
                        if (comp === "email_client" || comp === "message_softphone") {
                            // Remove customer_profile if adding email or softphone
                            const customerProfileIdx = this.selectedComponents.indexOf("customer_profile");
                            if (customerProfileIdx >= 0) {
                                this.selectedComponents.splice(customerProfileIdx, 1);
                            }
                        } else if (comp === "customer_profile") {
                            // Remove email_client and message_softphone if adding customer_profile
                            const emailIdx = this.selectedComponents.indexOf("email_client");
                            if (emailIdx >= 0) {
                                this.selectedComponents.splice(emailIdx, 1);
                            }
                            const softphoneIdx = this.selectedComponents.indexOf("message_softphone");
                            if (softphoneIdx >= 0) {
                                this.selectedComponents.splice(softphoneIdx, 1);
                            }
                        }
                        this.selectedComponents.push(comp);
                    }
                } else {
                    this.selectedConversationGroup = conversationGroup;
                    this.selectedComponents = [comp];
                }
            },
            setHtmlOverflow(value) {
                const htmlTag = document.getElementsByTagName('html')[0];
                if (!!htmlTag) {

                    // remove tags
                    htmlTag.classList.remove('overflow-y-hidden');
                    htmlTag.classList.remove('overflow-y-scroll');

                    // If hidden, need to scroll back to top
                    if (value === "hidden") {
                        window.scrollTo(0, 0);
                        htmlTag.classList.add('overflow-y-hidden');

                    } else if(value === "scroll"){
                        htmlTag.classList.add('overflow-y-scroll');
                    }
                }
                return;
            },
            showSnackbar(color, text) {
                if (color?.length > 0 && text?.length > 0) {
                    this.snackbar.color = color;
                    this.snackbar.text = text;
                    this.snackbar.show = true;
                }
            },
            sortConversationGroups(newConversationGroups) {
                return newConversationGroups?.sort((a, b) =>
                    (this.searchObj.sortByColumnName === "longest_waiting" ? Number(a.unresponded_incoming_message_id === null) - Number(b.unresponded_incoming_message_id === null) || (a.unresponded_incoming_message_id ?? Infinity) - (b.unresponded_incoming_message_id ?? Infinity) : 0) || // asc
                    (b.filtered_message_id || b.last_message_id || 0) - (a.filtered_message_id || a.last_message_id || 0) || // desc
                    (b.conversation_group_id || 0) - (a.conversation_group_id || 0) // desc
                );
            },
        },
        computed: {
            accountID() {
                return this.validSelectedConversationGroup ? (this.selectedConversationGroup?.account_id || 0) : 0;
            },
            colsUsed() {
                let cols = this.conversationGroupCardCols;

                if (this.renderCustomerProfile > 0) {
                    cols += 8;
                }

                if (this.renderEmailClient > 0) {
                    cols += 4;
                }

                if (this.renderMessageSoftphone > 0) {
                    cols += 4;
                }

                return cols >= 12 ? 12 : cols; // return max of 12 or col count
            },
            conversationGroupCardCols() {
                return this.spaceRatioValue === 0.5 ? 8 : 4;
            },
            conversationGroupIDs() {
                return this.conversationGroups?.map(cg => cg.conversation_group_id) || [];
            },
            customerID() {
                return this.validSelectedConversationGroup ? (this.selectedConversationGroup?.customer_id || 0) : 0;
            },
            customerPhoneNumberID() {
                return this.validSelectedConversationGroup ? (this.selectedConversationGroup?.customer_phone_number_id || 0) : 0;
            },
            filteredMessageID() {
                return this.validSelectedConversationGroup ? (this.selectedConversationGroup?.filtered_message_id || 0) : 0;
            },
            paddingCols() {
                return ((12.0 - this.colsUsed) * 1.0) / 2.0;
            },
            renderCustomerProfile() {
                return this.selectedComponents.indexOf("customer_profile") >= 0;
            },
            renderEmailClient() {
                return this.selectedComponents.indexOf("email_client") >= 0;
            },
            renderMessageSoftphone() {
                return this.selectedComponents.indexOf("message_softphone") >= 0;
            },
            selectedConversationGroupID() {
                return (this.selectedConversationGroup?.conversation_group_id || 0);
            },
            sourceValue() {
                return this.source?.length > 0 ? this.source : "conversation_groups_index";
            },
            spaceRatioValue() {
                const ratio = (this.spaceRatio || 0);
                return ratio > 0.0 && ratio <= 1.0 ? ratio : 1.0;
            },
            twilioNumberID() {
                return this.validSelectedConversationGroup ? (this.selectedConversationGroup?.twilio_number_id || 0) : 0;
            },
            validSelectedConversationGroup() {
                return this.selectedConversationGroupID > 0;
            },
            validConversationGroups() {
                return this.conversationGroups?.length > 0;
            },
            validGroupType() {
                return this.groupTypes.indexOf(this.groupType) >= 0;
            },
        },
        components: {
            BaseCustomerProfile,
            ConversationGroupCard,
            CustomerSearch,
            EmailClient,
            MessageSoftphone,
            OrganizationSelect,
        },
        props: {
            currentNavigation: String,
            cgAcknowledgedFromMsgScreen: Boolean,
            enterManualMode: Function,
            forceOrganizationUsers: Array,
            groupType: String,
            inCommunicationCenter: Boolean,
            source: String,
            spaceRatio: Number,
            viewProfile: Function,
        },
        watch: {
            currentNavigation() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
            isLoading() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
            "cgAcknowledgedFromMsgScreen"() {
                this.search();
            },
        },
        destroyed() {
            this.setHtmlOverflow("scroll");
            window.removeEventListener('resize', this.handleWindowResize);
            this.removeScrollListener();
        },
        created() {
            window.addEventListener('resize', this.handleWindowResize);
            this.resetAndSearch();
            return this.forceOrganizationUsers?.length > 0 ? (this.organizationUsers = this.forceOrganizationUsers) : this.getOrganizationUsers();
        },
        mounted() {
            this.setHtmlOverflow("hidden");
            this.handleWindowResize();
        },
    });
</script>

<style lang="scss" scoped>
</style>
